// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1287feed","299":"54882a1a","422":"20f52b57"}[chunkId] + ".chunk.js";
};